import React from 'react';
import { arrayOf, object, number } from 'prop-types';

import LabelMessage from '../atoms/LabelMessage';
import { useTranslate } from '../../translate/I18n';
import { MISSION } from '../../constants';

const { WARNING_MATCHING_FREELANCERS } = MISSION;

const getNumberOfMatchType = (numberOfMatch) => {
  if (numberOfMatch === null) {
    return 'default';
  }
  if (isNaN(numberOfMatch)) {
    return 'error';
  }
  if (numberOfMatch < WARNING_MATCHING_FREELANCERS) {
    return 'hint';
  }
  return 'success';
};

const MatchingFreelancersNumber = ({ matchingFreelancers }) => {
  const { t } = useTranslate(['mission']);

  return (
    <LabelMessage withIcon={true} type={getNumberOfMatchType(matchingFreelancers)} data-cy="matching-freelancers">
      {matchingFreelancers === null
        ? t('mission:calculatingMatchingFreelancers')
        : t('mission:matchingFreelancers', {
            count: matchingFreelancers
          })}
    </LabelMessage>
  );
};

MatchingFreelancersNumber.propTypes = {
  skills: arrayOf(object),
  matchingFreelancers: number
};

export default MatchingFreelancersNumber;
